export const eventSourceMethods = {
  data() {
    return {
      eventSource: {
        source: null,
        clientId: 0
      },
      signUrl: '', // 二维码扫码链接
      timer: null,
      reconnectCount: 1,
      isDialogLoading: false
    }
  },
  methods: {
    reSigna() {
      this.signUrl = ''
      // this.applyForm.autographFiles = []
      this.reconnectCount = 1
      this.reconnect()
    },
    // SSE重连
    reconnect() {
      this.isDialogLoading = true
      this.closeSseConnect()
      if (this.reconnectCount > 5) {
        this.isDialogLoading = false
        this.$message.error('连接失败，请刷新重连')
        return
      }
      this.timer = setTimeout(() => {
        this.reconnect()
      }, this.reconnectCount * 2000)
      const clientId = new Date().getTime()
      this.getEventSource(clientId)
      this.reconnectCount++
    },
    // 扫码链接
    getSignUrl(clientId) {
      this.signUrl =
        // 'https://gain.gsisc.cn/signa.html?clientId=' + clientId+'&url=https://api.gsisc.cn'+'&devUrl=' + this.urlConfig.devUrl
        this.urlConfig.sign+'?clientId=' + clientId+'&url=https://lanzhouapi.gsisc.cn'+'&devUrl='+this.urlConfig.devUrl
        // 'https://gain.gsisc.cn/signa.html?clientId=' + clientId+'&url=https://api.gsisc.cn'+'&devUrl=https://api.gsisc.cn'
    },
    // 与服务器建立SSE链接
    getEventSource(clientId) {
      if (typeof EventSource !== 'undefined') {
        // const url =  "http://123.249.24.8:9992" + approvalApi.createSseConnect() + '?clientId=' + clientId;
        const url =  `${urlConfig.url}apij2/admin-api/infra/sse/createSseConnect?clientId=${clientId}`
        console.log(url)
        // 建立连接
        const source = new EventSource(url)
        this.eventSource.source = source
        this.eventSource.clientId = clientId
        //    连接成功时触发该事件监听器
        source.onopen = (event) => {
          console.log('客户端与服务端连接成功……')
          clearTimeout(this.timer)
          this.isDialogLoading = false
          this.getSignUrl(clientId)
        }

        //  事件监听器： 服务端响应客户端时（推送消息）时触发事件监听器

        //  如果服务端指定 event: 事件类型时;  客户端需要设置该事件类型的监听器。
        source.onsseMessage = (event) => {
          console.log(event)
          if (
            event.data &&
            (event.data.indexOf('http://') === 0 ||
              event.data.indexOf('https://') === 0)
          ) {
            const name = event.data.substring(
              event.data.lastIndexOf('/') + 1,
              event.data.length
            )
            console.log(event.data);
            // this.applyForm.autographFiles = [
            //   { url: event.data, name: name, type: 'image' }
            // ]
            // if (this.signature) {
            //   if (!this.hallsignature) {
            //     this.form.sign_image_achievement = event.data
            //   }
            // } else {
            //   this.form.sign_image_market = event.data
            // }
            this.closeSseConnect()
          }
          console.log('推送消的消息' + event.data) // 推送的消息
        }

        // 如果服务端不指定 event: 事件类型时; 客户端则使用默认的事件监听器message
        source.onmessage = (event) => {
          console.log(event)
          if (
            event.data &&
            (event.data.indexOf('lanzhoufile') === 0 ||
              event.data.indexOf('lanzhoufile') === 0)
          ) {
            // const name = event.data.substring(
            //   event.data.lastIndexOf('/') + 1,
            //   event.data.length
            // )
            console.log(event.data);
            // this.applyForm.autographFiles = [
            //   { url: event.data, name: name, type: 'image' }
            // ]
            // this.applyForm.autographFiles = [
            //   { url: event.data, name: name, type: 'image' }
            // ]
            if (this.signature) {
              if (this.hallsignature) {
                if(!this.imageachievement){
                  this.form.sign_image_achievement = event.data
                }
              }else{
                this.form.sign_image_market = event.data
              }
            } else {
              
            }
            this.closeSseConnect()
          }
          console.log('推送消的消息' + event.data) // 推送的消息
        }

        //    执行出错时触发该事件监听器
        source.onerror = (event) => {
          console.log(event)
          this.reSigna()
        }
      } else {
        this.$message.error('当前浏览器不支持服务器发送的事件')
      }
    },
    async closeSseConnect() {
      if (this.eventSource.source) {
        this.eventSource.source.close()
        this.eventSource = {
          source: null,
          clientId: 0
        }
        // try {
        //   await approvalApi.closeSseConnect(clientId)
        // } catch (error) {}
      }
    }
  }
}
